import n, { css as i } from "styled-components";
import a from "../Icons/Spinner.js";
import o from "../../utils/colors.js";
import { device as t } from "../../utils/device.js";
const r = n.div`
  transition: all 0.5s ease-out;
  pointer-events: none;
  height: 24px;
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: -0.3px;
  text-align: center;
  color: ${o.white};

  @media ${t.isDesktop}, ${t.isTablet} {
    height: 24px;
    letter-spacing: -0.3px;
  }
`, c = n.button.attrs((e) => ({
  type: e.type || "button"
}))`
  transition: all 0.5s ease-out;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  font-family: VIC;
  box-sizing: border-box;
  vertical-align: middle;
  word-break: break-all;
  flex-wrap: nowrap;
  min-height: 50px;
  cursor: pointer;
  border-radius: 2px;
  background-color: ${o.orange};
  border: solid 1px ${o.orange};

  &:focus,
  &::-moz-focus-inner {
    border: none;
  }

  @media ${t.isTablet}, ${t.isDesktop} {
    padding-left: 13px;
    padding-right: 13px;
    min-width: 160px;
  }

  @media ${t.isMobile} {
    min-width: 200px;
    width: 100%;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 60%;
  }

  &:hover:not(:disabled),
  &:focus:not(:disabled) {
    border: solid 1px ${o.brown};
    background-color: ${o.brown};

    ${r} {
      color: ${o.white};
    }
  }

  ${(e) => e.$buttonType === "secondary" && i`
      border: solid 1px ${o.orange};
      background-color: ${o.white};

      ${r} {
        color: ${o.orange};
      }

      &:hover:not(:disabled),
      &:focus:not(:disabled) {
        border: solid 1px ${o.orange25};
        background-color: ${o.orange25};

        ${r} {
          color: ${o.brown};
        }
      }
    `}

  ${(e) => e.$buttonType === "tertiary" && i`
      border: none;
      background-color: transparent;

      ${r} {
        color: ${o.blueGrey};
        border-bottom: 3px solid ${o.orange};
      }

      &:hover:not(:disabled),
      &:focus:not(:disabled) {
        border: none;
        background-color: transparent;

        ${r} {
          color: ${o.orange};
        }
      }
  `};
`, b = n(a)`
  margin-left: 8px;
  width: 16px;
  height: 16px;
  margin-bottom: -2px;
`;
export {
  c as ButtonWrapper,
  b as LoadingSpinner,
  r as TextWrapper
};
